import { Button } from '@/components/ui/button';
import { ErrorText } from '../typography/ErrorText';
import { AlertTriangle } from 'lucide-react';

export interface ErrorProps {
  retry?: () => void;
  label?: string;
}

export const ErrorFallback: React.FC<ErrorProps> = ({ retry, label }) => {
  const message = label || 'An unexpected error occurred.';
  return (
    <div className="flex flex-col items-center justify-center h-full">
      <AlertTriangle className="my-2 text-destructive" />
      <ErrorText>{message}</ErrorText>
      {retry && (
        <Button variant="destructive" className="mt-4" onClick={retry}>
          Retry
        </Button>
      )}
    </div>
  );
};
